<div class="row">
	<!--<div class="col-12 header-modal">
		<button class="btn" type="button" (click)="onDismiss()"><i class="pi pi-times"></i></button>
	</div>-->
	<div class="col-12">
		<p-table
			dataKey="id"
			[value]="tableData"
			[tableStyle]="{ 'width': '100%' }"
			[styleClass]="'expanseRowTable'"
			[rowExpandMode]="'single'"
		>
			<ng-template pTemplate="header">
				<tr>
					<th style="width: 5rem"></th>
					<th *ngFor="let header of parentTableHeaders">{{ header.label }}</th>
					<th class="actions-table">
						<button class="btn btn-success" [disabled]="disabled" (click)="addItemData()"><i class="pi pi-plus-circle"></i>Add New</button>
					</th>
				</tr>
			</ng-template>
			<ng-template pTemplate="body" let-row let-indexParent="rowIndex" let-expanded="expanded">
				<tr>
					<td>
						<button class="btn" pRipple [pRowToggler]="row"><i
							class="pi {{expanded ? 'pi pi-chevron-down' : 'pi pi-chevron-right'}}"></i></button>
					</td>
					<td>{{ row.label }}</td>
					<td class="action-button">
						<button pButton pRipple type="button" [disabled]="disabled" (click)="editRowItem(row)" icon="pi pi-pencil"
								class="p-button-rounded p-button-warning edit-row-button"></button>

						<button pButton pRipple type="button" [disabled]="disabled" (click)="removeElement(indexParent, true)" icon="pi pi-trash"
								class="p-button-rounded p-button-danger delete-row-button"></button>
					</td>
				</tr>
			</ng-template>
			<ng-template pTemplate="rowexpansion" let-indexParent="rowIndex" let-row>
				<tr>
					<td colspan="7">
						<div class="p-3">
							<p-table [value]="row.value" dataKey="id">
								<ng-template pTemplate="header">
									<tr>
										<th *ngFor="let header of childTableHeaders">{{ header.label }}</th>
										<th class="actions-table">
											<button class="btn btn-success" [disabled]="disabled" (click)="addItemData(indexParent)"><i class="pi pi-plus-circle"></i>Add New
											</button>
										</th>
									</tr>
								</ng-template>
								<ng-template pTemplate="body" let-childRow let-indexChild="rowIndex" >
									<tr>
										<td>{{ childRow.label }}</td>
										<td class="action-button">
											<button pButton pRipple type="button" [disabled]="disabled" (click)="editRowItem(childRow)" icon="pi pi-pencil"
													class="p-button-rounded p-button-warning edit-row-button"></button>
											<button pButton pRipple type="button" [disabled]="disabled" (click)="removeElement(indexChild, false, indexParent)" icon="pi pi-trash"
													class="p-button-rounded p-button-danger delete-row-button"></button>
										</td>
									</tr>

								</ng-template>
								<ng-template pTemplate="emptymessage">
									<tr>
										<td colspan="6">There are no data yet.</td>
									</tr>
								</ng-template>
							</p-table>
						</div>
					</td>
				</tr>
			</ng-template>
		</p-table>
	</div>
</div>
